import { Plus, Calendar } from 'lucide-react';
import MeetingCard from './MeetingCard';

function formatDateDisplay(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const dateOnly = new Date(date);
  dateOnly.setHours(0, 0, 0, 0);

  if (dateOnly.getTime() === today.getTime()) {
    return 'Today';
  }
  if (dateOnly.getTime() === tomorrow.getTime()) {
    return 'Tomorrow';
  }

  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });
}

export default function DayMeetingsList({
  date,
  meetings,
  selectedMeeting,
  onMeetingSelect,
  onAddMeeting
}) {
  if (!date) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
        <Calendar size={32} className="text-text-muted mb-3" />
        <p className="text-sm text-text-secondary">
          Select a date to view meetings
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col min-h-0">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <h3 className="text-sm font-semibold text-text-primary">
          {formatDateDisplay(date)}
        </h3>
        <button
          onClick={onAddMeeting}
          className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-accent hover:bg-accent-muted rounded-lg transition-colors"
        >
          <Plus size={14} />
          Add
        </button>
      </div>

      {/* Meetings list */}
      <div className="flex-1 overflow-y-auto p-3 space-y-2">
        {meetings.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <p className="text-sm text-text-tertiary mb-3">
              No meetings scheduled
            </p>
            <button
              onClick={onAddMeeting}
              className="text-xs text-accent hover:text-accent-bright transition-colors"
            >
              Schedule a meeting
            </button>
          </div>
        ) : (
          meetings.map((meeting, index) => (
            <MeetingCard
              key={meeting.id || `virtual-${index}`}
              meeting={meeting}
              isSelected={selectedMeeting?.id === meeting.id || (meeting.isVirtual && selectedMeeting?.isVirtual && selectedMeeting?.seriesId === meeting.seriesId)}
              onClick={() => onMeetingSelect(meeting)}
            />
          ))
        )}
      </div>
    </div>
  );
}
